import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  CSBPlusBannerCurrentDate,
  CSBPlusBannerOE,
  newOECount,
  reactivatedOECount,
  totalOECount,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {currentScreen} from '/redux/selector/navigation.selector';
import {variablesBannerText} from '/redux/selector/remoteConfig.selector';
import {withProps} from '/util/selector.util';

import {CSBPlusBanner} from './CSBPlusBanner';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    newOrderingEntities: withCurrentUserCoachId(CSBPlusBannerOE),
    currentDate: withCurrentUserCoachId(CSBPlusBannerCurrentDate),
    currentScreen: currentScreen,
    bannerText: variablesBannerText,
    reactivatedOECount: withCurrentUserCoachId(reactivatedOECount),
    newOECount: withCurrentUserCoachId(newOECount),
    totalOECount: withCurrentUserCoachId(totalOECount),
  }),
  _dispatch => ({}),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
    };
  },
)(CSBPlusBanner);
